export default __webpack_public_path__ + "static/media/points-star.ba884ba2.svg";